import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-[1180px]" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4"
}
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "mt-1 text-amber-800" }
const _hoisted_5 = {
  key: 1,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = { class: "flex gap-x-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_11 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_12 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_13 = { class: "flex justify-end" }
const _hoisted_14 = {
  key: 2,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_15 = { class: "grid grid-cols-2 gap-x-4 gap-y-6" }
const _hoisted_16 = { class: "flex justify-end" }

import { CheckIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, ref } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputArea from '@/components/neue/InputArea'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import NeueToggle from '@/components/neue/NeueToggle'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import TheModal from '@/components/TheModal.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'

// Floors sized to the rendered header labels (text-xs uppercase tracking-wider);
// "Free delivery / shipping" is the widest and sets the 185px floor.

export default {
  __name: 'StorePricingTiers',
  props: ['id'],
  setup(__props) {

const tierCols = [
  { width: 'minmax(90px, 1fr)' },
  { width: 'minmax(90px, 1fr)' },
  { width: 'minmax(90px, 1fr)' },
  { width: 'minmax(185px, 1.4fr)' },
  { width: 'minmax(125px, 1fr)' },
  { width: '90px' }
]

const membershipPairCols = [{ width: 'minmax(120px, 1fr)' }, { width: '80px' }]

const discountTypeOptions = [
  { name: 'Percent off', value: 'percent_off' },
  { name: 'Amount off', value: 'amount_off' }
]
const amountOff = () =>
  modal.value.discountType === 'amount_off' ? Math.round(Number(modal.value.amountOff) * 100) || 0 : 0
const rateOff = () => (modal.value.discountType === 'amount_off' ? 0 : Number(modal.value.discount) / 100 || 0)

const loading = ref(true)
const modal = ref({ open: false })
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const allow = ref(false)
const tierThreshold = tier => tier.attributes.minimum_item_count || tier.attributes.minimum_price?.cents || 0
const membershipLabel = tier => {
  if (tier.attributes.available_for_all_membership_tiers) return 'All'
  const pairs = tier.relationships.membership_tier_pricing_tier_pairs?.data || []
  return pairs.length ? 'Selected tiers' : 'None'
}
const tiers = computed(() => {
  const all = mapRelationships(store.value?.relationships.pricing_tiers.data)
  return [...all].sort((a, b) => {
    if (a.attributes.is_default) return -1
    if (b.attributes.is_default) return 1
    return tierThreshold(a) - tierThreshold(b)
  })
})
const memberships = computed(() => mapType('membership_tier'))

onMounted(async () => {
  api.call('GET', 'membership_tiers?included=none&limit=50')
  await api.call('GET', `stores/${props.id}?included=pricing_tiers,pricing_tiers.membership_tier_pricing_tier_pairs`)
  loading.value = false
  allow.value = store.value.attributes.allow_tipping
})

const refreshStoreWarning = () => api.call('GET', `stores/${props.id}?included=none`)

const addTier = () => {
  api.call('POST', `stores/${store.value.id}/pricing_tiers`, { pricing_tier: { title: 'New tier' } }).then(response => {
    editTier(response.data.data, true)
    refreshStoreWarning()
  })
}

const membershipOptions = computed(() => memberships.value.map(x => ({ name: x.attributes.tier_name, value: x })))

const editTier = (tier, fromAdd) => {
  if (tier.attributes.is_default) return
  modal.value = {
    open: true,
    mode: fromAdd ? 'add' : 'edit',
    tier,
    name: tier.attributes.title,
    description: tier.attributes.subtitle,
    discountType: tier.attributes.discount_type || 'percent_off',
    discount: Math.round(tier.attributes.rate_off * 10000) / 100,
    amountOff: ((tier.attributes.amount_off?.cents || 0) / 100).toFixed(2),
    freeShipping: tier.attributes.free_shipping,
    minimumPrice: (tier.attributes.minimum_price.cents / 100).toFixed(2),
    minimumItems: tier.attributes.minimum_item_count || 0,
    availableForAll: tier.attributes.available_for_all_membership_tiers,

    newMembership: memberships.value[0],
    membershipPairs: mapRelationships(tier.relationships.membership_tier_pricing_tier_pairs.data)
  }
}

const addMembership = async () => {
  const response = await api.call('PUT', `stores/${props.id}/pricing_tiers/${modal.value.tier.id}`, {
    pricing_tier: {
      membership_tier_pricing_tier_pairs_attributes: [{ membership_tier_id: modal.value.newMembership.id }]
    }
  })
  modal.value.tier = response.data.data
  modal.value.membershipPairs = mapRelationships(modal.value.tier.relationships.membership_tier_pricing_tier_pairs.data)
}

const deleteMembership = async pair => {
  const response = await api.call('PUT', `stores/${props.id}/pricing_tiers/${modal.value.tier.id}`, {
    pricing_tier: { membership_tier_pricing_tier_pairs_attributes: { id: pair.id, _destroy: true } }
  })
  modal.value.tier = response.data.data
  modal.value.membershipPairs = mapRelationships(modal.value.tier.relationships.membership_tier_pricing_tier_pairs.data)
}

const saveTier = async () => {
  modal.value.minimumPrice = Number(modal.value.minimumPrice).toFixed(2)
  modal.value.amountOff = Number(modal.value.amountOff).toFixed(2)
  await api.call('PUT', `stores/${props.id}/pricing_tiers/${modal.value.tier.id}`, {
    pricing_tier: {
      title: modal.value.name,
      subtitle: modal.value.description,
      discount_type: modal.value.discountType,
      rate_off: rateOff(),
      amount_off_cents: amountOff(),
      free_shipping: modal.value.freeShipping,
      minimum_price_cents: modal.value.minimumPrice * 100 || null,
      minimum_item_count: modal.value.minimumItems || null,
      available_for_all_membership_tiers: modal.value.availableForAll
    }
  })
  refreshStoreWarning()
}

const deleteTier = async tier => {
  if (!confirm(`Delete ${tier.attributes.title}?`)) return
  await api.call('DELETE', `stores/${props.id}/pricing_tiers/${tier.id}`, {}, { delete: false })
  refreshStoreWarning()
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Your tiers",
            description: "Reward bigger orders. A tier applies its discount, and optionally free delivery or shipping, once an order reaches the amount you set.",
            plain: ""
          }, {
            default: _withCtx(() => [
              (store.value?.attributes?.pricing_tier_warning)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_unref(ExclamationTriangleIcon), {
                      class: "h-6 w-6 flex-shrink-0 text-amber-500",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "font-semibold text-amber-900" }, "Pricing tier setup issue", -1)),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(store.value.attributes.pricing_tier_warning), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (tiers.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(NeueTablist), null, {
                      head: _withCtx(() => [
                        _createVNode(_unref(TablistHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TablistGrid), {
                              columns: tierCols,
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[14] || (_cache[14] = _createElementVNode("div", null, "Name", -1)),
                                _cache[15] || (_cache[15] = _createElementVNode("div", null, "Amount", -1)),
                                _cache[16] || (_cache[16] = _createElementVNode("div", null, "Discount", -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("div", null, "Free delivery / shipping", -1)),
                                _cache[18] || (_cache[18] = _createElementVNode("div", null, "Membership tier", -1)),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_unref(NeueButton), {
                                    type: "secondary",
                                    onClick: _withModifiers(addTier, ["prevent"])
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("+ Tier", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiers.value, (tier) => {
                          return (_openBlock(), _createBlock(_unref(TablistRow), {
                            key: tier.id,
                            class: _normalizeClass(!tier.attributes.is_default && 'cursor-pointer'),
                            onClick: $event => (!tier.attributes.is_default && editTier(tier, false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TablistGrid), {
                                columns: tierCols,
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(tier.attributes.title), 1),
                                  _createElementVNode("div", _hoisted_7, [
                                    (tier.attributes.minimum_price.cents)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(tier.attributes.minimum_price.format), 1))
                                      : (tier.attributes.minimum_item_count)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(tier.attributes.minimum_item_count) + " " + _toDisplayString(tier.attributes.minimum_item_count > 1 ? 'items' : 'item'), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_10, "—"))
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(tier.attributes.discount_label), 1),
                                  _createElementVNode("div", null, [
                                    (tier.attributes.free_shipping)
                                      ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                          key: 0,
                                          class: "h-5 w-5"
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "—"))
                                  ]),
                                  _createElementVNode("div", null, [
                                    (tier.attributes.is_default)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(membershipLabel(tier)), 1)
                                        ], 64))
                                  ]),
                                  _createElementVNode("div", _hoisted_13, [
                                    (!tier.attributes.is_default)
                                      ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                          key: 0,
                                          class: "h-6 w-6 hover:text-black",
                                          onClick: _withModifiers($event => (deleteTier(tier)), ["stop"])
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!tiers.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_unref(EmptyState), { plural: "pricing tiers" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NeueButton), {
                          type: "secondary",
                          onClick: _withModifiers(addTier, ["prevent"])
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode("+ Tier", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(TheModal, {
      "is-open": modal.value.open,
      "modal-title": modal.value.mode === 'add' ? 'Add pricing tier' : 'Edit pricing tier',
      onCloseModal: _cache[11] || (_cache[11] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), { size: "3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((modal.value.name) = $event)),
                  name: "Name",
                  onChange: saveTier
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), { size: "3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectInput), {
                  modelValue: modal.value.discountType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.value.discountType) = $event)),
                  name: "Discount type",
                  options: discountTypeOptions,
                  onChange: saveTier
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (modal.value.discountType === 'amount_off')
              ? (_openBlock(), _createBlock(_unref(FormElement), {
                  key: 0,
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.amountOff,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.amountOff) = $event)),
                      name: "Discount",
                      prefix: "$",
                      restrict: "monetary",
                      onChange: saveTier
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(FormElement), {
                  key: 1,
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.discount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.discount) = $event)),
                      name: "Discount",
                      suffix: "%",
                      restrict: "float",
                      onChange: saveTier
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputArea), {
                  modelValue: modal.value.description,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.description) = $event)),
                  name: "Description",
                  onChange: saveTier
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: modal.value.freeShipping,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((modal.value.freeShipping) = $event)),
                  name: "Free delivery / shipping",
                  onChange: saveTier
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.minimumItems,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((modal.value.minimumItems) = $event)),
                      name: "Minimum quantity of products required in this category to allow checkout",
                      prefix: "#",
                      onChange: saveTier
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.minimumPrice,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((modal.value.minimumPrice) = $event)),
                      name: "Minimum dollar amount",
                      "name-placeholder": "Minimum quantity of products required in this category to allow checkout",
                      prefix: "$",
                      onChange: saveTier
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: modal.value.availableForAll,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((modal.value.availableForAll) = $event)),
                  name: "Available for all membership tiers",
                  onChange: saveTier
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!modal.value.availableForAll)
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectInput), {
                      modelValue: modal.value.newMembership,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((modal.value.newMembership) = $event)),
                      name: "Select a membership",
                      options: membershipOptions.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!modal.value.availableForAll)
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NeueButton), {
                      type: "primary",
                      onClick: addMembership
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("Add", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!modal.value.availableForAll && modal.value.membershipPairs.length)
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NeueTablist), null, {
                      head: _withCtx(() => [
                        _createVNode(_unref(TablistHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TablistGrid), {
                              columns: membershipPairCols,
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("div", null, "Membership tier", -1),
                                _createElementVNode("div", null, null, -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.membershipPairs, (pair) => {
                          return (_openBlock(), _createBlock(_unref(TablistRow), {
                            key: pair.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TablistGrid), {
                                columns: membershipPairCols,
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_unref(mapRelationship)(pair.relationships.membership_tier.data).attributes.tier_name), 1),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_unref(XCircleIcon), {
                                      class: "cursor-pointer h-6 w-6 hover:text-black",
                                      onClick: _withModifiers($event => (deleteMembership(pair)), ["stop"])
                                    }, null, 8, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => (modal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode("Done", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"])
  ], 64))
}
}

}